"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _orbitDesignTokens = require("@kiwicom/orbit-design-tokens");

var _default = {
  orbit: _orbitDesignTokens.defaultTokens,
  transitions: true,
  rtl: false
};
exports.default = _default;